"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionParser = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const bignumber_js_1 = require("bignumber.js");
const types_1 = require("../../types");
const utils_1 = require("./utils");
class TransactionParser {
    constructor(args) {
        this.chainId = args.chainId;
        this.assetId = (0, caip_1.toAssetId)({
            ...(0, caip_1.fromChainId)(this.chainId),
            assetNamespace: 'slip44',
            assetReference: caip_1.ASSET_REFERENCE.Cosmos
        });
    }
    async parse(tx, address) {
        var _a, _b;
        const parsedTx = {
            address,
            blockHash: tx.blockHash,
            blockHeight: (_a = tx.blockHeight) !== null && _a !== void 0 ? _a : -1,
            blockTime: (_b = tx.timestamp) !== null && _b !== void 0 ? _b : Math.floor(Date.now() / 1000),
            chainId: this.chainId,
            confirmations: tx.confirmations,
            status: tx.confirmations > 0 ? types_1.Status.Confirmed : types_1.Status.Pending,
            transfers: [],
            txid: tx.txid
        };
        // For simplicity and to limit scope we assume 1 message per transaction
        // This works ok enough for transactions we generate but way may want to improve in the future
        const { from, to, data, value, origin } = (0, utils_1.valuesFromMsgEvents)(tx.messages[0], tx.events, this.assetId);
        parsedTx.data = data;
        if (from === address && value.gt(0)) {
            parsedTx.transfers = [
                {
                    type: types_1.TransferType.Send,
                    assetId: this.assetId,
                    from,
                    to,
                    totalValue: value.toString(10),
                    components: [{ value: value.toString(10) }]
                }
            ];
        }
        if (to === address && value.gt(0)) {
            parsedTx.transfers = [
                {
                    type: types_1.TransferType.Receive,
                    assetId: this.assetId,
                    from,
                    to,
                    totalValue: value.toString(10),
                    components: [{ value: value.toString(10) }]
                }
            ];
        }
        // We use origin for fees because some txs have a different from and origin addresses
        if (origin === address) {
            // network fee
            const fees = new bignumber_js_1.BigNumber(tx.fee.amount);
            if (fees.gt(0)) {
                parsedTx.fee = { assetId: this.assetId, value: fees.toString(10) };
            }
        }
        return parsedTx;
    }
}
exports.TransactionParser = TransactionParser;
